module.exports = __webpack_public_path__ + "static/img/sv.b880c913.svg";